<template>
  <picture>
    <source :media="`(max-width: ${images.desktop.width}px)`" :srcset="images.mobile.url" />
    <img :src="images.desktop.url" class="ad__image" alt="" />
  </picture>
</template>

<script>
export default {
  name: 'AdImage',
  props: {
    images: {
      type: Object,
      required: true,
    },
  },
}
</script>
